<template>
  <div>
 
    <div class="loader-wrapper" v-if='showLoader'>
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div>
  
    <nav class="navbar navbar-expand-lg theme-nav fixed-top">
      <div class="container">
        <router-link class="navbar-brand" to="/chatloop"
          ><img src="../assets/images/logo.png" alt="logo" />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#mainmenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"
            ><i
              class="fa fa-align-justify"
              aria-hidden="true"
              @click="toggleNavbar('navbar')"
            ></i
          ></span>
        </button>
        <div
          class="collapse navbar-collapse"
          id="mainmenu"
          :class="responsiveNav ? 'show' : ''"
        >
          <ul class="navbar-nav ml-auto" id="mymenu">
            <li class="nav-item">
              <router-link class="nav-link" to="/chatloop/index#home"
                >Home</router-link
              >
            </li>
            <li class="nav-item dropdown" @click="toggleNavbar('blogList')">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >Blog</a
              >
              <ul
                class="dropdown-menu"
                :class="responsiveBlogList ? 'show' : ''"
              >
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blog-list"
                    >blog list</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blog-details"
                    >blog details</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blogs-leftside"
                    >leftsidebar
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/blogs-rightside"
                    >rightsidebar
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/chatloop/blog-details-with-leftsidebar"
                    >details leftsidebar</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/chatloop/blog-details-with-rightsidebar"
                  >
                    details rightsidebar</router-link
                  >
                </li>
              </ul>
            </li>

            <li
              class="nav-item dropdown"
              @click="toggleNavbar('otherPagesList')"
            >
              <a
                class="nav-link dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >Other Page</a
              >
              <ul
                class="dropdown-menu"
                :class="responsiveOthePageslist ? 'show' : ''"
              >
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/sign-in"
                    >Sign In</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/sign-up"
                    >Sign Up</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/forgot-pass"
                    >Forget Password</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/thank-you"
                    >Thank You</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/review"
                    >Review</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/FAQ-page"
                    >FAQ</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/coming-soon"
                    >Coming Soon</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/download"
                    >Download</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/request"
                    >Request Demo</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/chatloop/404"
                    >404</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
   
    <section class="theme-bg home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="home-contain">
              <div class="fadeInLeft-land-caption">
                <h2 class="landing-caption text-white">
                  Best App Landing for all your needs.. !
                </h2>
                <p class="text-white">
                  Chatloop is perfect landing page for game , photoediting ,
                  browser or any mobile application landing page
                </p>
                <div>
                  <router-link
                    to="/chatloop/index"
                    class="btn btn-inverse mt-2 mr-3"
                    >Ltr Demo</router-link
                  >
                  <router-link to="/chatloop/rtl" class="btn btn-inverse mt-2"
                    >Rtl Demo</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 right">
            <div class="home-right">
              <div class="mobile-slid">
                <img
                  src="../assets/images/demo/home/weightlifting.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="photo">
                <img
                  src="../assets/images/demo/home/photo-Editing-app.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
              <div class="gym">
                <img
                  src="../assets/images/demo/home/gym-app.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="game">
                <img
                  src="../assets/images/demo/home/game-app.png"
                  alt="top4"
                  class="img-fluid"
                />
              </div>
              <div class="msg">
                <img
                  src="../assets/images/demo/home/messanger.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
              <div class="broweser">
                <img
                  src="../assets/images/demo/home/browser.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="love-emoji">
                <img
                  src="../assets/images/top5.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
 
    <section class="fadinup" id="home-demo">
      <div class="container-fluid m-width">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="section-title mb-2">
              <h2>View Landing Page</h2>
              <img
                src="../assets/images/title-line.png"
                alt="title-line"
                class="img-fluid"
              />
            </div>
          </div>
          <div class="col-lg-6 offset-lg-3 col-md-10 offset-md-1">
            <p class="demo-description">
              Clean and clear designs makes websites differ from others. We've
              pre-build demo for giving you as much as flexibility in making
              your site unique.
            </p>
          </div>
        </div>
        <div class="row mt-35 landing-screen-animation">
          <div class="col-xl-4 col-lg-6 col-12 text-center offset-xl-2">
            <div>
              <router-link :to="{ name: 'Index' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/ltr.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">ltr demo</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Indexrtl' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/rtl.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Rtl demo</h2>
          </div>
        </div>
      </div>
    </section>
  
    <section class="fadin-blog pt-0">
      <div class="container m-width">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="section-title mb-2">
              <h2>Other Page</h2>
              <img
                src="../assets/images/title-line.png"
                alt="title-line"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="row mt-35 pages-space">
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Bloglist' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-list.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog List</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Blogdetails' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-details.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog-details</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Blogsleftside' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-list-left.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog list with sidebar</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Blogsrightside' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-list-right.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog list with right sidebar</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Blogleftsidebar' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-details-left-sidebar.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog details with sidebar</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Blogrightsidebar' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/blog-details-right-sidebar.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">blog details with right sidebar</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Signup' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/sign-in.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Sign In</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Signin' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/sign-up.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Sign Up</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Forgotpassword' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/forget.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Forget Password</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Comingsoon' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/comingsoon.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Coming Soon</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Request' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/request.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Request Schedule demo page</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Review' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/review.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Review</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'Downloadpage' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/download.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Download Page</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'FAQpage' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/faq.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">FAQ</h2>
          </div>
          <div class="col-xl-4 col-lg-6 col-12 text-center">
            <div>
              <router-link :to="{ name: 'pagenotfound' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/404.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">404 Error Page</h2>
          </div>
          <div
            class="col-xl-4 col-lg-6 col-12 text-center offset-xl-4 offset-lg-0"
          >
            <div>
              <router-link :to="{ name: 'Thankyou' }">
                <span class="pc-bg">
                  <span
                    :style="{
                      backgroundImage:
                        'url(\'' +
                        require('../assets/images/demo/thankyou.jpg') +
                        '\')',
                    }"
                    class="img-scroll"
                  ></span>
                </span>
              </router-link>
            </div>
            <h2 class="demo-title">Thank You</h2>
          </div>
        </div>
      </div>
    </section>
  
    <section class="features-bg mb-0">
      <div class="container m-width">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-12 text-center">
              <div class="section-title mb-2">
                <h2>Features of chatloop</h2>
                <img
                  src="../assets/images/title-line.png"
                  alt="title-line"
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="border-shape"></div>
            <div class="mt-50">
              <ul class="features m-0 p-0 fadeIn-features">
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/vue.png"
                      class="img-fluid"
                      alt="html5"
                    />
                    <h3 class="features-title">VUE</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/css-3.png"
                      class="img-fluid"
                      alt="css"
                    />
                    <h3 class="features-title">Css 3</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/sass.png"
                      class="img-fluid"
                      alt="Scss"
                    />
                    <h3 class="features-title">SCSS</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/ps.png"
                      class="img-fluid"
                      alt="PSD"
                    />
                    <h3 class="features-title">Free PSD</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/bootstrap-4.png"
                      class="img-fluid"
                      alt="bootstrap-4"
                    />
                    <h3 class="features-title">bootstrap 5</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/animate-css.png"
                      class="img-fluid"
                      alt="animate-css"
                    />
                    <h3 class="features-title">Animate css</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/responsive.png"
                      class="img-fluid"
                      alt="responsive"
                    />
                    <h3 class="features-title">Responsive</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/google-fonts-support.png"
                      class="img-fluid"
                      alt="Google-fonts"
                    />
                    <h3 class="features-title">Google fonts support</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/w3c-validation.png"
                      class="img-fluid"
                      alt="w3c-validation"
                    />
                    <h3 class="features-title">W3C Validation</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/pixel-perfect-design.png"
                      class="img-fluid"
                      alt="Pixel-Perfect"
                    />
                    <h3 class="features-title">Pixel Perfect Design</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/all-broweser-support.png"
                      class="img-fluid"
                      alt="browser-support"
                    />
                    <h3 class="features-title">all browser support</h3>
                  </div>
                </li>
                <li>
                  <div class="features-img">
                    <img
                      src="../assets/images/features/rtl.png"
                      class="img-fluid"
                      alt="rtl"
                    />
                    <h3 class="features-title">rtl support</h3>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
   
    <section class="theme-bg pt-70 m-0 pb-0 grab">
      <div class="container m-width">
        <div class="row">
          <div class="col-xl-5 offset-xl-1 col-md-6">
            <div class="tamp-d-flex">
              <div>
                <h2 class="tapl-title fadeInLeft-land-caption mb-5">
                  Stop thinking, Just grab it
                </h2>
                <router-link to="#" class="btn btn-inverse"
                  >Download</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-xl-5 offset-xl-1 col-md-6">
            <div class="home-right grab-img">
              <div class="mobile-slid">
                <img
                  src="../assets/images/top-mobile.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
              <div class="profile-msg">
                <img
                  src="../assets/images/top2.png"
                  alt="top2"
                  class="img-fluid"
                />
              </div>
              <div class="awesome">
                <img
                  src="../assets/images/top3.png"
                  alt="top3"
                  class="img-fluid"
                />
              </div>
              <div class="emoji">
                <img
                  src="../assets/images/top5.png"
                  alt="top5"
                  class="img-fluid"
                />
              </div>
              <div class="profile-2">
                <img
                  src="../assets/images/top1.png"
                  alt="top1"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   
    <section>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="tamp-d-flex">
              <div>
                <p class="coming-title rating-title">
                  If you love this template please rate us
                </p>
                <div class="rating-star">
                  <img src="../assets/images/star.png" alt="star" />
                  <img src="../assets/images/star.png" alt="star" />
                  <img src="../assets/images/star.png" alt="star" />
                  <img src="../assets/images/star.png" alt="star" />
                  <img src="../assets/images/star.png" alt="star" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   
    <div class="bg-light">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="Copyright-section">
              <p>2018- 19 Copyright &copy; powered by Pixelstrap</p>
            </div>
          </div>
        </div>
      </div>
    </div>
 
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
      showLoader: false
    };
  },
  watch: {
    $route() {
      this.showLoader = true;
      setTimeout(() => {
        this.showLoader = false
      }, 1000);
    }
  },
  methods: {
   
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
   
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
